export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9824.93bee917.jpg";